import { get } from "../builders";

type Notice = Record<string, unknown>;

export const statusPageNotices = () =>
  get<{ notices?: Notice[] }>(
    "https://www.glesys-status.com/api/v1/notices?filter[timeline_state_in][]=present&filter[timeline_state_in][]=future",
  );
